// extracted by mini-css-extract-plugin
module.exports = {"mainbox":"Industry_mainbox__3zlsT","content":"Industry_content__4Xzff","article":"Industry_article__3ZCCb","aleft":"Industry_aleft__1Kljq","aright":"Industry_aright__2m1Mp"};